module.exports = __webpack_public_path__ + "static/media/gifts.7a948168.svg";